import { IconWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Chip, Typography } from '@mui/material';
const styles: IStyles = {
    root: {
        height: { xs: pxToRem(102), md: pxToRem(78), lg: pxTovW(119) },
        width: { xs: '100%', md: '100%' },
        borderRadius: { xs: pxToRem(10), md: pxToRem(10), lg: pxTovW(10) },
        backgroundColor: '#FFFFFF',
        border: '1px solid #E0DFDE',
        padding: {
            xs: `${pxToRem(12)} ${pxToRem(12)} ${pxToRem(12)} ${pxToRem(12)}`,
            md: pxToRem(14),
            lg: `${pxTovW(17)} ${pxTovW(20)}`
        },
        display: 'flex',
        alignItems: 'center',
        gap: { xs: pxToRem(10), md: pxToRem(21), lg: pxTovW(24) },
        boxSizing: 'border-box',
        boxShadow: '0px 0px ${pxToRem(4)} rgba(0, 0, 0, 0.08)',
    },
    imageBox: {
        height: { xs: pxToRem(30), md: pxToRem(28), lg: pxTovW(36) },
        width: { xs: pxToRem(30), md: pxToRem(28), lg: pxTovW(36) },
        backgroundColor: '#EFF4EF',
        borderRadius: { xs: pxToRem(5), md: pxToRem(5), lg: pxTovW(5) },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
};
interface IProps {
    serialNumber: string;
    contentName: string;
    taskName?: string;
    duration?: string;
}

export const ProjectContentCard = (props: IProps) => {
    const { serialNumber, contentName, taskName, duration } = props;
    return (
        <Box sx={styles.root}>
            <Box sx={styles.imageBox}>
                <Typography variant='bodyText' fontWeight={700}>{serialNumber}</Typography>
            </Box>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: pxToRem(8), lg: pxTovW(8) }
                    }}
                >
                    <Chip
                        label={taskName}
                        sx={{
                            height: { xs: pxToRem(22), md: pxToRem(21), lg: pxTovW(24) },
                            width: 'max-content',
                            backgroundColor: 'warning.main',
                            fontSize: { md: '12px' },
                            fontWeight: 'bold'
                        }}
                    />
                    <Typography variant="h5" fontWeight="bold">
                        {contentName}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        boxSizing: 'border-box',
                        justifyContent: 'space-between',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: { xs: pxToRem(5), md: pxToRem(5), lg: pxTovW(5) },
                            width: 'max-content',
                            alignItems: 'center',
                        }}
                    >
                        <IconWrapper
                            name="clock"
                            size="small"
                            parentFolder="icons"
                            type="png"
                        />
                        <Typography variant="subText" fontWeight={700} color="#007CDC">
                            {duration}
                        </Typography>
                    </Box>
                    {/* <Box
                        sx={{
                            display: 'flex',
                            gap: { xs: pxToRem(5), md: pxToRem(5), lg: pxTovW(5) },
                            width: 'max-content',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="smallestText" color={'secondary.main'}>
                            {contentType}
                        </Typography>
                    </Box> */}
                </Box>
            </Box>
        </Box>
    );
};
